import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextRoot } from "src/Contexts/Root/RootContext";
import { api } from "src/shared/setup/API/api";

export const useHttpTableUsers = () => {
  const { setListUsers } = useContextRoot();
  const { handleGetAlert } = useLayoutMainContext();

  const {
    setQtdRegisters,
    setLoadingTable,
    itensPerPage,
    currentPage,
    nameSearch,
  } = useConfigPageContext();

  const handleGet = async () => {
    setLoadingTable(true);

    api
      .get(
        `/admin/users?page=${currentPage}&pageSize=${itensPerPage}&filter=${nameSearch}`
      )
      .then((res) => {
        setListUsers(res.data.data);
        setQtdRegisters(res.data.meta.total);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet };
};
